function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 22,
  fill: "#00C3E1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M31.912 14.071l2.356 1.858L20.61 33.254l-7.58-7.58 2.121-2.122 5.193 5.193z"
}));

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NiIgaGVpZ2h0PSI0NiIgdmlld0JveD0iMCAwIDQ2IDQ2Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGNpcmNsZSBjeD0iMjMiIGN5PSIyMyIgcj0iMjIiIGZpbGw9IiMwMEMzRTEiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIzMS45MTIgMTQuMDcxIDM0LjI2OCAxNS45MjkgMjAuNjEgMzMuMjU0IDEzLjAzIDI1LjY3NCAxNS4xNTEgMjMuNTUyIDIwLjM0NCAyOC43NDUiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgCheckCircle as ReactComponent };